/* ============================================
BOOST CUSTOMISATION START
Cart Sync — assets/boost-cart-sync.js
(session 5, v2.2.5 — DEPRECATED STUB)

WHY THIS FILE IS EMPTY IN v2.2.5

  v2.2.4 introduced this file to handle automatic decoration-line
  qty propagation by watching cart mutations via patched window.fetch
  and window.XMLHttpRequest.

  v2.2.4 testing (T-0518-034/035/036) revealed that a third-party
  script — Shopify analytics, Klaviyo, or another installed app —
  wraps window.fetch AFTER our defer-loaded scripts run, burying our
  patched fetch under their wrapper. Our reconcile callback never
  fired on interactive /cart/change.js calls. Diagnostic evidence:
    > window.fetch.toString().slice(0, 200)
    returned minified third-party wrapper code, not our patch.

  v2.2.5 abandons the fetch-patching approach for the entire reconcile
  path. The decoration-qty sync logic that lived here is now part of
  the unified reconciler in boost-cart-fee-manager.js, triggered by
  MutationObserver on the cart drawer and cart page DOM. DOM mutations
  cannot be intercepted by third-party scripts the way fetch can.

  This file remains in /assets so the existing <script> tag in
  layout/theme.liquid does not 404 on cached theme references during
  deployment. The next iteration of the theme can safely remove both
  the file and the script tag together; doing so now risks a brief
  404 window if any merchandiser tools or staging environments hold
  references to the file.

NO BEHAVIOUR
  This file intentionally contains no executable code. It is loaded
  but does nothing.
============================================ */
(function () {
  'use strict';
  // No-op. See file header for context.
})();
/* ============================================
BOOST CUSTOMISATION END
============================================ */
